import { CompareActions } from 'features/products-compare';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getValidationError } from 'features/products-compare/ducks/selectors/validation';

export type StatusType = 'error' | 'success';

type UseGetTextParams = {
  operationType: CompareActions | null;
  status: StatusType;
};

type MessageKey = {
  success: string;
  error?: string;
};

export const useGetText = ({ operationType, status }: UseGetTextParams): string => {
  const { t } = useTranslation();
  const validationError = useSelector(getValidationError);

  if (validationError) {
    return t('ui.compare.status-add-alert');
  }
  if (operationType === CompareActions.REQUEST) {
    return '';
  }

  const MESSAGE_KEYS: Record<string, MessageKey> = {
    [CompareActions.ADD]: {
      success: t('ui.compare.status-add-success'),
      error: t('ui.compare.status-add-error'),
    },
    [CompareActions.DELETE]: {
      success: t('ui.compare.status-delete-success'),
      error: t('ui.compare.status-delete-error'),
    },
    [CompareActions.DELETE_GROUP]: {
      success: t('ui.compare.status-delete-success'),
      error: t('ui.compare.status-delete-error'),
    },
  } as const;

  const messageKey = MESSAGE_KEYS[operationType as keyof typeof MESSAGE_KEYS]?.[status];
  return messageKey ? messageKey : '';
};
